import { useEffect } from 'react';
import { logout } from './accounts';
import { OPERATOR_EVENT, OPERATOR_KEY, saveOperatorToken } from './operator';
import {
  clearSessionDeadline, SESSION_TIMEOUT_MS, sessionDeadline, setSessionDeadline, watchSessionExpiry,
} from './sessionTimeout';

export function useOperatorTimeout(cameraActive: boolean): void {
  useEffect(() => {
    let leaving = false;
    const beginAbsence = (): void => {
      const token = localStorage.getItem(OPERATOR_KEY);
      if (token && sessionDeadline(OPERATOR_KEY, token) === null) {
        setSessionDeadline(OPERATOR_KEY, token, Date.now() + SESSION_TIMEOUT_MS);
      }
    };
    const hide = (): void => { leaving = true; beginAbsence(); };
    const show = (): void => { leaving = false; };
    const absent = (): boolean => !cameraActive || leaving || document.visibilityState === 'hidden';
    const startIfAbsent = (): void => { if (absent()) beginAbsence(); };
    window.addEventListener('pagehide', hide);
    window.addEventListener('pageshow', show);
    window.addEventListener(OPERATOR_EVENT, startIfAbsent);
    document.addEventListener('visibilitychange', startIfAbsent);
    startIfAbsent();
    const stop = watchSessionExpiry(() => {
      const token = localStorage.getItem(OPERATOR_KEY);
      if (!token) return null;
      const deadline = sessionDeadline(OPERATOR_KEY, token);
      if (deadline !== null && deadline <= Date.now()) {
        saveOperatorToken(null);
        void logout(token).catch(error => console.warn('[session-timeout] Could not revoke administrator session', error));
        return null;
      }
      if (!absent()) {
        clearSessionDeadline(OPERATOR_KEY);
        return null;
      }
      return sessionDeadline(OPERATOR_KEY, token);
    }, [OPERATOR_EVENT]);
    return () => {
      stop();
      window.removeEventListener('pagehide', hide);
      window.removeEventListener('pageshow', show);
      window.removeEventListener(OPERATOR_EVENT, startIfAbsent);
      document.removeEventListener('visibilitychange', startIfAbsent);
      if (cameraActive) beginAbsence();
    };
  }, [cameraActive]);
}
